import {
  SummaryItemPaymentType,
  SummaryItemType
} from '@features/add-to-cart-page/components/SummaryStore/SummaryStore.types';
import type {
  EnrichedShoppingCartItem,
  MappedShoppingCartItem
} from '@features/add-to-cart-page/typings/ShoppingCart';

import { EnabledCrossSellChargerProductTypes } from '../constants';

export default function getCrossSellCharger(
  shoppingCartItems: EnrichedShoppingCartItem[],
  mainProductShoppingCartItem?: MappedShoppingCartItem
) {
  const crossSellCharger = shoppingCartItems.find(
    item =>
      EnabledCrossSellChargerProductTypes.includes(
        Number(item.product?.productType?.productTypeId ?? '0')
      ) &&
      new Date(mainProductShoppingCartItem?.modificationDate ?? '').getTime() -
        new Date(item.modificationDate).getTime() <
        500
  );

  if (!crossSellCharger) {
    return [];
  }

  return [
    {
      id: crossSellCharger.product?.id,
      name: crossSellCharger.product?.name || '',
      quantity: 1,
      type: SummaryItemType.CrossSellCharger,
      paymentType: SummaryItemPaymentType.OneTime,
      showPrice: true,
      salesPrice: {
        includingVat: crossSellCharger.product?.salesPrice?.includingVat || 0
      },
      shortName: crossSellCharger.product?.shortName || ''
    }
  ];
}
